import configs from './configs'
export default {
    "search": {
        "en": "Search",
        "ar": "بحث"
    },
    "save": {
        "en": "save",
        "ar": "حفظ"
    },
    "send": {
        "en": "send",
        "ar": "إرسال"
    },
    "confirm": {
        "en": "confirm",
        "ar": "تأكيد"
    },
    "edit": {
        "en": "edit",
        "ar": "تعديل"
    },
    "delete": {
        "en": "delete",
        "ar": "حذف"
    },
    "reset": {
        "en": "Reset",
        "ar": "إعادة ضبط"
    },
    "cancel": {
        "en": "cancel",
        "ar": "إلغاء"
    },
    "back": {
        "en": "back",
        "ar": "رجوع"
    },

    "create": {
        "en": "Create",
        "ar": "إنشاء"
    },

    "yes": {
        "en": "Yes",
        "ar": "نعم"
    },

    "no": {
        "en": "No",
        "ar": "لا"
    },

    "close": {
        "en": "Close",
        "ar": "إغلاق"
    },
    
    "add": {
        "en": "Add",
        "ar": "إضافة"
    },

    "export-excel": {
        "en": "Export excel",
        "ar": "تصدير لإكسل"
    },

    "update": {
        "en": "Update",
        "ar": "تحديث"
    },
    
    "ok": {
        "en": "Ok",
        "ar": "موافق"
    },

    "import": {
        "en": "Import",
        "ar": "يستورد"
    },

    "print": {
        "en": "Print",
        "ar": "طباعة"
    },

    "tabs": {
        "en": {
            "staff": "Staff",
            "customers": "Customers",
            "external": "External",
            "doctor-visits": `${configs.doctorVisits.en}`,
            "pharmacy-visits": `${configs.pharmacyVisits.en}`,
            "center-visits": `${configs.centerVisits.en}`,
            "all": "All",
            "double-visit-reports": "Double visit reports",
            "Administrative-reports": "Administrative reports",
            "deliver": "Deliver",
            "receive": "Receive",
            "doctor": `${configs.doctor.en}`,
            "pharmacy": `${configs.pharmacy.en}`,
            "center": `${configs.center.en}`,
            "cities": "Cities",
            "regions": "Regions",
            "area": "Area"
        },
        "ar": {
            "staff": "طاقم العمل",
            "customers": "الزبائن",
            "external": "جهات خارجية",
            "doctor-visits": `${configs.doctorVisits.ar}`,
            "pharmacy-visits": `${configs.pharmacyVisits.ar}`,
            "center-visits": `${configs.centerVisits.ar}`,
            "all": "الكل",
            "double-visit-reports": "تقارير الزيارات المزدوجة",
            "administrative-reports": "تقارير الإدارين",
            "receive": "المستلم",
            "deliver": "المسلم",
            "doctor": `${configs.doctor.ar}`,
            "pharmacy": `${configs.pharmacy.ar}`,
            "center": `${configs.center.ar}`,
            "cities": "المدن",
            "regions": "المناطق",
            "area": "القطاعات"    
        }
    },

    "inputs": {
        "en": {
            "date": "Date",
            "employees": "Employees",
            "type": "Type",
            "name": "Name",
            "product-name": "Product name",
            "start-date": "Start date",
            "end-date": "End date",
            "pharmaceutical-form": `${configs.pharmaceuticalForm.en}`,
            "username": "Username",
            "password": "Password",
            "number": "Number",
            "volume": "Volume",
            "pills-per-box": `${configs.pillsPerBox.en}`,
            "leaflet-url": "Leaflet URL",
            "strength": "Strength",
            "price": "Price",
            "paid-leave": "Paid leave",
            "days-count": "Days count",
            "reason": "Reason",
            "city": "City",
            "region": "Region",
            "specialty": `${configs.specialty.en}`,
            "class": "Class",
            "doctor": `${configs.doctor.en}`,
            "medical-rep": "Medical rep",
            "request-type": "Request type",
            "pending": "Pending",
            "accepted": "Accepted",
            "rejected": "Rejected",
            "all": "All",
            "customers": "Customers",
            "max-amount": "Max amount",
            "min-amount": "Min amount",
            "account": "Account",
            "input-quantity": "Input quantity",
            "out-quantity": "Output quantity",
            "item": "Item",
            "notes": "Notes",
            "customer-type": "Customer type",
            "amount": "amount",
            "customer": "Customer",
            "areas": "Areas",

            "duration-in-minutes": "Duration in minutes",
            "core-message": "Core message",
            "objections": "Objections",
            "next-call": "Next Call",
            "unavailable-products": "Unavailable products",
            "competitors": "Competitors",
            "center-notes": `${configs.centerNotes.en}`,
            "entity-name": "Customer name",
            "employee": "Employee",
            "salary": "Salary",
            "transportation-allowance": "Transportation allowance",
            "living-cost-compensation": "Living cost compensation",
            "retention-bonus": "Retention bonus",
            "communication-allowance": "Communication allowance",
            "liability-compensation": "Liability compensation",
            "rewards": "Rewards",
            "rebates": "Rebates",
            "total-salary": "Total salary",
            "net-salary": "Net salary",
            "birthday": "Birthday",
            "telephone-number": "Telephone number",
            "phone-number": "Phone number",
            "address": "Address",
            "email": "Email",
            "team": "Team",
            "province": "Province",
            "other-samples": "Other samples",
            "role": "Role",
            "specialties": "Specialties",
            "target": "Target",
            "line-manager": "Line manager",
            "direct-manager": "Direct manager",
            "job-title": "Job title",
            "manager": "Manager",
            "doctor-name": `${configs.doctorName.en}`,
            "loyalty": "Loyalty",
            "religion": "Religion",
            "personality": "Personality",
            "weekend": "Weekend",
            "nearby-pharmacy-1": "Nearby pharmacy 1",
            "nearby-pharmacy-2": "Nearby pharmacy 2",
            "works-in-centers": "Works in centers",
            "work-hours-from": "Work Hours from",
            "personal-note": "Personal note",
            "doctor-hobbies": `${configs.doctorHobbies.en}`,
            "visit-notes": "Visit notes",
            "pharmacist-info": `${configs.pharmacistInfo.en}`,
            "pharmacy-info": "Pharmacy info",
            "resident-doctors": "Resident doctors",
            "center-is-specialty": "Center's specialty",
            "best-time-to-visit": "Best time to visit",
            "full-address": "Full address",
            "cities": "Cities",
            "material": "Materials",
            "description": "Description",
            "rural": "Rural",
            "administrative": "Administrative",
            "activities": "Activities",
            "doctors": `${configs.doctors.en}`,
            "pharmacies": `${configs.pharmacies.en}`,
            "centers": `${configs.centers.en}`,
            "sample": "Sample",
            "note": "Note",
            "hiring-date": "Hiring date",
            "area": "Area",
            center: `${configs.center.en}`,
            pharmacy: `${configs.pharmacy.en}`,
            'employee-photo': "employee photo",
            'certificate': 'Certificate',
            "gender": "Gender",
            "male": "Male",
            "female": "Female",
            "teams": "Teams",
            "leave-days-number": "Leave days number",
            'visits-quality': 'Visits quality',
            'exam-result': 'Exam Result',
            'region-sales': 'Region sales',
            'area-sales': 'Area sales',
            "cooperation": "Cooperation",
            "commitment": "Commitment",
            "behavior": "Behavior",
            "appearance": "Appearance",
            "total": "Total",
            "activity": 'Activity',
            "target-upper-limits-value": "Target upper limits value",
            "target-lower-limits-value": "Target lower limits value",
            "financial-target-value": "Financial target value",
            "currency": "Currency",
            "payment-method": "Payment method",
            "residant-doctor-names": "Names of resident doctors",
            "discount-rate": "Discount rate",
            "posted": "Posted",
            "unPosted": "UnPosted",
            "amount-delivered": "Amount delivered",
            "amount-received": "Amount received",
            "price-type": "Price type",
            "free": "free",
            "regions": "Regions",
            "least-visit-first" : "Least visit first",
            "prices-types": "Prices types"
        },
        "ar": {
            "date": "تاريخ",
            "employees": "الموظفين",
            "type": "النوع",
            "name": "الاسم",
            "product-name": "اسم المادة",
            "start-date": "تاريخ البداية",
            "end-date": "تاريخ النهاية",
            "pharmaceutical-form": `${configs.pharmaceuticalForm.ar}`,
            "username": "اسم المستخدم",
            "password": "كلمة المرور",
            "number": "الرقم",
            "volume": "الكمية",
            "pills-per-box": `${configs.pillsPerBox.ar}`,
            "leaflet-url": "صورة الصنف ",
            "strength": "التركيز",
            "price": "السعر",
            "paid-leave": "إجازة مدفوعة",
            "days-count": "عدد الأيام",
            "reason": "السبب",
            "city": "المدينة",
            "region": "المنطقة",
            "specialty": `${configs.specialty.ar}`,
            "class": "التصنيف",
            "doctor": `${configs.doctor.ar}`,
            "medical-rep": `${configs.medicalRep.ar}`,
            "request-type": "نوع الطلب",
            "pending": "قيد الانتظار",
            "accepted": "مقبول",
            "rejected": "مرفوض",
            "all": "الكل",
            "customers": "لزبائن",
            "max-amount": "الحد الأعلى",
            "min-amount": "الحد الأدنى",
            "account": "الحساب",
            "input-quantity": "الكمية الداخلة",
            "out-quantity": "الكمية الخارجة",
            "item": "المادة",
            "notes": "الملاحظات",
            "customer-type": "النوع",
            "amount": "الكمية",
            "customer": "الزبون",
            "area": "",
            "duration-in-minutes": "مدة الزيارة بالدقائق",
            "core-message": "الرسالة الأساسية",
            "objections": "الاعتراضات",
            "next-call": "الزيارة القادمة",
            "unavailable-products": "المواد الغير متوفرة",
            "competitors": "المنافسين",
            "center-notes": "ملاحظات المركز",
            "entity-name": "اسم الجهة",
            "employee": "الموظف",
            "salary": "الراتب",
            "transportation-allowance": "بدل المواصلات",
            "living-cost-compensation": "بدل تكاليف المعيشة",
            "retention-bonus": "مكافأة الاحتفاظ",
            "communication-allowance": "بدل الاتصالات",
            "liability-compensation": "تعويض المسؤولية",
            "rewards": "المكافأت",
            "rebates": "الخصومات",
            "total-salary": "إجمالي الراتب",
            "net-salary":"صافي الراتب",
            "birthday": "المواليد",
            "telephone-number": "رقم الهاتف",
            "phone-number": "رقم الموبايل",
            "address": "العنوان",
            "email": "البريد الإلكتروني",
            "team": "الفريق",
            "province": "المحافظة",
            "other-samples": "مواد أخرى",
            "role": "الدور الوظيفي",
            "specialties": "التخصصات",
            "target": "عدد الزيارات المطلوب في الشهر",
            "line-manager": "المدير",
            "direct-manager": "المدير المباشر",
            "job-title": "المسمى الوظيفي",
            "manager": "المدير",
            "doctor-name": `${configs.doctorName.ar}`,
            "loyalty": "الولاء",
            "religion": "الديانة",
            "personality": "الشخصية",
            "weekend": "العطلة",
            "nearby-pharmacy-1": "أقرب صيدلية(1)",
            "nearby-pharmacy-2": "أقرب صيدلية(2)",
            "works-in-centers": "يعمل في مراكز",
            "work-hours-from": "ساعات العمل من ",
            "personal-note": "معلومات شخصية",
            "doctor-hobbies": `${configs.doctorHobbies.ar}`,
            "visit-notes": "ملاحظات الزيارة",
            "pharmacist-info": `${configs.pharmacistInfo.ar}`,
            "pharmacy-info": "معلومات ",
            "resident-doctors": "الأطباء المقيمين",
            "center-is-specialty": "تخصص المركز",
            "best-time-to-visit": "أفضل وقت للزيارة",
            "full-address": "العنوان الكلي",
            "cities": "المدن",
            "materials": "المواد",
            "description": "الوصف",
            "rural": "ريف",
            "administrative": "إداري",
            "activities": "الأنشطة",
            "doctors": `${configs.doctors.ar}`,
            "pharmacies": `${configs.pharmacies.ar}`,
            "centers": `${configs.centers.ar}`,
            "sample": "المواد",
            "note": "الملاحظة",
            "hiring-date": "تاريخ البدء",
            center: `${configs.center.ar}`,
            pharmacy: `${configs.pharmacy.ar}`,
            'employee-photo': "صورة الموظف",
            'certificate': 'الشهادة',
            "gender": "الجنس",
            "male": "ذكر",
            "female": "أنثى",
            "teams": "الفرق",
            "leave-days-number": "عدد أيام الإجازة",
            'visits-quality': 'جودة الزيارات',
            'exam-result': 'نتائج الاختبار',
            'region-sales': 'مبيعات المنطقة',
            'area-sales': 'مبيعات المنطقة',
            "cooperation": "تعاون",
            'commitment': 'التزام',
            "behavior": "سلوك",
            "appearance": "مظهر",
            "total": "المجموع",
            "activity": "النشاط",
            "target-upper-limits-value": "الحد الأعلى للمبيعات",
            "target-lower-limits-value": "الحد الأدنى للمبيعات",
            "financial-target-value": "قيمة الهدف المالي",
            "currency": "العملة",
            "payment-method": "طريقة الدفع",
            "residant-doctor-names": "أسماء الأطباء الموجودين",
            "discount-rate": "نسبة الحسم",
            "posted": "مرحلة",
            "unPosted": "غير مرحلة",
            "amount-delivered": "المبلغ المُسلَّم",
            "amount-received": "المبلغ المستلم",
            "price-type": "نوع السعر",
            "free": "مجاني",
            "regions": "المناطق",
            "least-visit-first": "الأقل زيارة أولا",
            "prices-types": "أتواع الأسعار"
        }
    },
    "headers": {
        "en": {
            "account": "Account",
            "item": "Item",
            "amount": "amount",
            "notes": "Notes",
            "deliver-date": "Deliver date",
            "material": "Material",
            "remaining": "Remaining",
            "input-quantity": "Input quantity",
            "output-quantity": "output quantity",
            "date": "Date",
            "product-name": "Product name",
            "pharmaceutical-form": `${configs.pharmaceuticalForm.en}`,
            "volume": "Volume",
            "pills-per-box": `${configs.pillsPerBox.en}`,
            "strength": "Strength",
            "price": "Price",
            "description": "Description",
            "actions": "Actions",
            "employee-name": "Employee name",
            "specialty": `${configs.specialty.en}`,
            "class": "Class",
            "doctor": `${configs.doctor.en}`,
            "city": "City",
            "region": "Region",
            "core-message": "Core message",
            "objection": "Objection",
            "next-call": "Next call",
            "employee": "Employee",
            "request-type": "Request type",
            "request-state": "Request state",
            "days": "Days",
            "reason": "Reason",
            "medical-rep": "Medical rep",
            "exam-link": "Exam link",
            "salary": "salary",
            "transportation-allowance": "Transportation allowance",
            "living-cost-compensation": "Living cost compensation",
            "retention-bonus": "Retention bonus",
            "communication-allowance": "Communication allowance",
            "liability-compensation": "Liability compensation",
            "rewards": "Rewards",
            "rebates": "Rebates",
            "net-salary": "Net salary",
            "team": "Team",
            "phone-number": "Mobile number",
            "telephone-number": "Telephone number",
            "work-period": "Work period",
            "role": "Role",
            "email": "Email",
            "address": "Address",
            "entity-name": "Customer name",
            "sample-name": "Sample name",
            "samples-amount": "Samples amount",
            "other-samples": "Other samples",
            "duration": "Duration",
            "number-of-visits": "Number of visits",
            "customer": "Customer",
            "quantity": "Quantity",
            "max-amount": "Max amount",
            "min-amount": "Min amount",
            "material-name": "Material name",
            "available": "Available",
            "sell-price": "Sell price",
            "state": "State",
            "report": "Rports",
            "transaction-from-visit": "Transaction from visit",
            "note": "Note",
            "visits-count": "Visits Count",
            "submission-date": "Submission date",
            "remaining-total-leaves": "Remaining / Total leaves",
            "start-date": "Start date",
            "end-date": "End date",
            "samples": "Samples",
            "name": "Name",
            "specialties": "Specialties",
            "permissions": "Permissions",
            "explanation": "Explanation",
            "contact-type": "Contact type",
            "contact": "Contact",
            "full-address": "Full address",
            "classification": "Classification",
            "area": "Area",
            "best-time-to-visit": "Best time to visit",
            "visit-time": "Visit time",
            "visit-time-from": "Visit time from",
            "visit-time-to": "Visit time to",
            "from-to-account": "from / to account",
            "pharmacy": `${configs.pharmacy.en}`,
            "center": `${configs.center.en}`,
            'received': "Received",
            "provided": "Provided",
            
            'visits-quality': 'visits quality ',
            'exam-result': 'exam result ',
            'region-sales': 'region sales',
            'area-sales': 'Area sales',
            "cooperation": "cooperation",
            'commitment': 'commitment',
            "behavior": "behavior",
            "appearance": "appearance",
            "total": "total",
            "participation": "Participation",
            "scientific-&-marketing-participation": "Scientific & Marketing Participation",
            "commitment-&-punctuality": "Commitment & Punctuality",
            "unavailable-products": "Unavailable products",
            "payment-method": "Payment method",
            "currency": "Currency",
            "free": "Free",
            "amount-delivered": "Amount delivered",
            "amount-received": "Amount received",
            "posted": "Posted",
            "status": "Status",
            "price-type": "Price type",
            'discount': 'Discount',
            "total-amount": "Total amount",
            "is-constant": "is constant",
            "visit-count": "Number of visit",
            'contact-information': 'Contact information'
        },
        "ar": {
            "account": "الحساب",
            "item": "المادة",
            "amount": "الكمية",
            "notes": "الملاحظات",
            "deliver-date": "تاريخ التسليم",
            "material": "المادة",
            "remaining": "المتبقي",
            "input-quantity": "الكمية الداخلة",
            "output-quantity": "الكمية الخارجة",
            "date": "التاريخ",
            "product-name": "اسم المادة",
            "pharmaceutical-form": `${configs.pharmaceuticalForm.ar}`,
            "volume": "الكمية",
            "pills-per-box": `${configs.pillsPerBox.ar}`,
            "strength": "التركيز",
            "price": "السعر",
            "description": "الوصف",
            "actions": "الأوامر",
            "employee-name": "اسم الموظف",
            "specialty": `${configs.specialty.ar}`,
            "class": "التصنيف",
            "doctor": `${configs.doctor.ar}`,
            "city": "المدينة",
            "region": "المنطقة",
            "core-message": "الرسالة الأساسية",
            "objection": "الاعتراض",
            "next-call": "المكالمة التالية",
            "employee": "الموظف",
            "request-type": "نوع الطلب",
            "request-state": "حالة الطلب",
            "days": "الأيام",
            "reason": "السبب",
            "medical-rep": "المندوب",
            "exam-link": "رابط الاختبار",
            "salary": "الراتب",
            "transportation-allowance": "بدل المواصلات",
            "living-cost-compensation": "بدل تكاليف المعيشة",
            "retention-bonus": "مكافأة الاحتفاظ",
            "communication-allowance": "بدل الاتصالات",
            "liability-compensation": "تعويض المسؤولية",
            "rewards": "المكافأت",
            "rebates": "الخصومات",
            "net-salary": "صافي الراتب",
            "team": "الفريق",
            "phone-number": "رقم الموبايل",
            "telephone-number": "رقم الهاتف",
            "work-period": "فترة العمل",
            "role": "الدور الوظيفي",
            "email": "البريد الإلكتروني",
            "address": "العنوان",
            "entity-name": "اسم الجهة",
            "sample-name": "اسم المادة",
            "sample-amount": "كمية المواد المسلمة",
            "other-samples": "مواد أخرى",
            "duration": "الفترة",
            "number-of-visits": "عدد الزيارات",
            "customer": "الزبون",
            "quantity": "الكمية",
            "max-amount": "الحد الأعلى",
            "min-amount": "الحد الأدنى",
            "material-name": "اسم المادة",
            "available": "المتوفر أو المتبقي",
            "sell-price": "السعر",
            "state": "السبب",
            "transaction-from-visit": "مناقلة من زيارة",
            "note": "الملاحظة",
            "visits-count": "عدد الزيارات",
            "submission-date": "تاريخ التقديم",
            "remaining-total-leaves": "المتبقي / عدد الإجازات الكلي",
            "start-date": "تاريخ البداية",
            "end-date": "تاريخ النهاية",
            "samples": "المواد",
            "name": "الاسم",
            "specialties": " التخصصات",
            "permissions": "الصلاحيات",
            "explanation": "توضيح",
            "contact-type": "نوع جهة التواصل",
            "contact": "جهة التواصل",
            "full-address": "العنوان كاملا",
            "classification": "التصنيف",
            "area": "",
            "best-time-to-visit": "أفضل وقت للزيارة",
            "visit-time": "وقت الزيارة",
            "visit-time-from": "وقت الزيارة من ",
            "visit-time-to": "وقت الزيارة إلى",
            "samples-amount": "كمية المواد",
            "from-to-account": "من / إلى حساب",
            "pharmacy": `${configs.pharmacy.ar}`,
            "center": `${configs.center.ar}`,
            'received': "استلام",
            "provided": "مستلم",

            'visits-quality': 'جودة الزيارات',
            'exam-result': 'نتائج الاختبار',
            'region-sales': 'مبيعات المنطقة',
            'area-sales': 'مبيعات المنطقة',
            "cooperation": "تعاون",
            'commitment': 'التزام',
            "behavior": "سلوك",
            "appearance": "مظهر",
            "total": "المجموع",
            "participation": "مشاركة",
            "scientific-&-marketing-participation": "المشاركة العلمية و التسويقية",
            "commitment-&-punctuality": "الالتزام و الالتزام بالمواعيد",
            "unavailable-products": "المواد الغير متوفرة",
            "payment-method": "طريقة الدفع",
            "currency": "العملة",
            "free": "مجاني",
            "amount-delivered": "المبلغ المُسلَّم",
            "amount-received": "المبلغ المستلم",
            "posted": "مرّحلة",
            "status": "الحالة",
            "price-type": "نوع السعر",
            "discount": "الحسم",
            "total-amount": "الكمية الكلية",
            "is-constant": "ثابتة",
            "visit-count": "عدد الزيارات",
            "contact-information": "معلومات التواصل"
        }
    },

    "select-all": {
        "en": "Select all",
        "ar": "الكل"
    },

    "are-you-sure-you-want-to": {
        "en": "Are you sure you want to",
        "ar": "هل أنت متأكد من"
    },

    "shown-rows": {
        "en": "Shown rows",
        "ar": "الأسطر المعروضة"
    },

    "from-date": {
        "en": "From date",
        "ar": "من تاريخ"
    },
    "to-date": {
        "en": "To date",
        "ar": "إلى تاريخ"
    },
    "daily-date": {
        "en": "Daily date",
        "ar": "يومي"
    },
    "the-visit": {
        "en": "the visit",
        "ar": "الزيارة"
    },

    "?": {
        "en": "?",
        "ar": "؟"
    },
    "edit-doctor": {
        "en": `${configs.editDoctor.en}`,
        "ar": `${configs.editDoctor.ar}`
    },
    "delete-doctor": {
        "en": `${configs.deleteDoctor.en}`,
        "ar": `${configs.deleteDoctor.ar}`
    },
    "contact-information": {
        "en": "Contact information",
        "ar": "معلومات الاتصال"
    },

    "facebook-profile-url": {
        "en": "Facebook profile Url",
        "ar": "رابط الملف الشخصي على الفيسبوك"
    },
    "not-found-data": {
        "en": "Not found data",
        "ar": "لم يتم العثور على البيانات"
    },

    "message": {
        "en": {
            "employee-is-added": "Employee is added",
            "employee-is-edited": "Employee is edited",
            "employee-account-status-has-been-toggled-successfully": "Employee account status has been toggled successfully",
            "delete-operation-completed-successfully": 'Delete operation completed successfully.',
            "data-is-deleted": "Data is deleted"
        },
        "ar": {
            "employee-is-added":  "تم إضافة الموظف",
            "employee-is-edited": "تمت تعديل الموظف",
            "employee-account-status-has-been-toggled-successfully": "تم تبديل حالة حساب الموظف بنجاح.",
            "delete-operation-completed-successfully": "تمت عملية الحذف بنجاح",
            "data-is-deleted": "تم حذف البيانات"
        }
    },

    "userTypes": {
        "en": {
            "medical-rep": `${configs.medicalRep.en}`,
            "administrative": "Administrative"
        },
        "ar": {
            "medical-rep": `${configs.medicalRep.ar}`,
            "administrative": "إداري"
        }
    },

    "accept": {
        "en": "Accept",
        "ar": "قبول"
    },
    "reject": {
        "en": "Reject",
        "ar": "رفض"
    },
    "new": {
        "en": "New",
        "ar": "جديد "
    },

    "vacations-balance": {
        "en": "Vacations balance",
        "ar": "رصيد الإجازات"
    },
    "logout": {
        "en": "Logout",
        "ar": "تسجيل الخروج"
    },
    "import-excel-file": {
        "en": "import excel file",
        "ar": "استيراد ملف اكسل"
    },
    "excel-file": {
        "en": "Excel file",
        "ar": "ملف الاكسل"
    },
    "select-excel-file": {
        "en": "Select excel file",
        "ar": "اختر ملف الاكسل"
    },
    "donwload-excel-file-template": {
        "en": "Donwload Excel file template",
        "ar": "قم بتنزيل قالب ملف الاكسل"
    },
    "excel-fle-is-imported": {
        "en": "Excel File is Imported",
        "ar": "تم استيراد ملف اكسل"
    },
    "imported-but-there-is-an-error-in-rows": {
        "en": "Imported, but there is an error in rows",
        "ar": "تم الاستيراد ولكن هناك خطأ في الصفوف"
    },

    "please-wait-to-fetch-data": {
        "en": "Please wait to fetch data!",
        "ar": "انتظر  لجلب البيانات رجاءَ!"
    },
    leaves: {
        "ar": {
            'administrative-day': "يوم إداري",
            'administrative-leave': "إجازة إدارية",
            'half-administrative-day': "إجازة نصف يوم إدارية",
            "sick-leave": "إجازة مرضية",
            "unpaid-leave": "إجازة غير مدفوعة"
        },
        "en": {
            'administrative-day': "Administrative day",
            'administrative-leave': "Administrative leave",
            'half-administrative-day': "Half administrative day",
            "sick-leave": "Sick leave",
            "unpaid-leave": "Unpaid leave"
        }
    },
    "work-data": {
        "en": "Work data",
        "ar": "بيانات العمل"
    },
    "day-off-requests": {
        "en": "Day off requests",
        "ar": "طلبات الإجازة"
    },
    "samples": {
        "en": "Samples",
        "ar": "المواد"
    },
    "rates": {
        "en": "Rates",
        "ar": "النتائج"
    },

    "show-your-employees": {
        "en": "Show your employees",
        "ar": "عرض الموظفين التابعين له"
    },

    "this": {
        "en": "this",
        "ar": "هذا"
    },

    "created": "تم إنشاء ",
    "edited": "تم تعديل",
    "data": {
        "en": "data",
        "ar": "بيانات"
    },
    payment: {
        "en": {
            'cash': 'Cash',
            'credit': 'Creit',
            'debt': 'Debt'
        },
        "ar": {
            'cash': 'نقدي',
            'credit': 'بطاقة',
            'debt': 'دَين'
        }
    },

    "edit-visit": {
        "en": "Edit visit",
        "ar": "تعديل زيارة"
    },

    "delete-visit": {
        "en": "Delete visit",
        "ar": "حذف زيارة"
    },
    "add-prices-for-an-item": {
        "en": "Add price for an item",
        "ar": "إضافة سعر لمادة"
    },
    "please-enter-the-type-price-for-this-item": {
        "en": "please enter the {type} price for this item",
        "ar": "من فضلك ادخل سعر ( {type} ) لهذه المادة "
    },
    "sepacilaties-statistics": {
        en: "Number of doctors by specialty",
        ar: "عدد الاطباء حسب التخصصات"
    }
}